export enum BaseIds {
  BaseCatalog = "548f9654-5369-41ed-b1e9-80bb04477dbe",
  BaseAttributeGroup = "67f7f916-0654-44b4-9632-d0d895b66630"
}
